import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDatatableModule } from '@emerald-angular/datatable';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldInputModule } from '@emerald-angular/input';
import { SharedModule } from '@shared/shared.module';
import { EmeraldModalModule } from '@emerald-angular/modal';
import { EmeraldAccordionGroupModule } from '@emerald-angular/accordion-group';
import { OpsCandidatesComponent } from './ops-candidates/ops-candidates.component';
import { OpsOpenPositionsComponent } from './ops-open-positions/ops-open-positions.component';
import { OpenPositionFilterComponent } from '@shared/modals/open-position-filter/open-position-filter.component';
import { CandidateFilterComponent } from '@shared/modals/candidate-filter/candidate-filter.component';
import { OpsJobDetailsComponent } from './ops-job-details/ops-job-details.component';
import { JobDetailsFilterComponent } from '@shared/modals/job-details-filter/job-details-filter.component';
import { AuthGuard } from '@core/okta-auth.guard';
import { CandidateFeedbackComponent } from '@shared/modals/candidate-feedback/candidate-feedback.component';
import { AddHttpsPipe } from '@shared/pipes/add-https.pipe';
import { EmeraldTooltipModule } from '@emerald-angular/tooltip';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { OpenPositionsFlagLegendComponent } from '@shared/components/open-positions-flag-legend/open-positions-flag-legend.component';
import { TruncatetextpipePipe} from '@shared/pipes/truncatetextpipe.pipe';
import { CommonModule } from '@angular/common';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';

const routes: Routes = [
  {
    path: 'ops',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: OpsOpenPositionsComponent },
      { path: 'job-details', component: OpsJobDetailsComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [
    EmeraldTabBarModule,
    EmeraldButtonModule,
    EmeraldDatatableModule,
    EmeraldIconModule,
    EmeraldInputModule,
    SharedModule,
    RouterModule.forChild(routes),
    EmeraldModalModule,
    EmeraldAccordionGroupModule,
    OpenPositionFilterComponent,
    OpenPositionsFlagLegendComponent,
    JobDetailsFilterComponent,
    CandidateFeedbackComponent,
    CandidateFilterComponent,
    AddHttpsPipe,
    EmeraldTooltipModule,
    EmeraldDropdownModule,
    TruncatetextpipePipe,
    CommonModule,
    ModalWrapperComponent,
  ],
  exports: [
    OpsOpenPositionsComponent,
    OpsCandidatesComponent,
  ],
  declarations: [
    OpsOpenPositionsComponent,
    OpsCandidatesComponent,
    OpsJobDetailsComponent,
  ],
})
export class OpsModule {}
